'use client';
import Carousel from "@/components/Carousel";
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.PicturesSlice} PicturesSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PicturesSlice>} PicturesProps
 * @param {PicturesProps}
 */

const PictureItem = ({ index, item, variation }) => {
  return <div key={index} className="flex-1 text-center">
    <div>
      <div className={` ${variation === "default" ? 'rounded-3xl' : 'rounded-full'} border-2 mb-4 border-dark-grey overflow-hidden relative `}>
        <PrismicImage field={item.picture} className={`${variation === "default" ? 'h-[370px] md:h-[300px]' : 'h-[400px]'} lg:min-h-[600px] lg:h-[60vh] w-full object-cover object-center`} loading={index === 0 ? '' : 'lazy'} />
        {
          item.cta_label && item.cta_page && <PrismicLink field={item.cta_page}><div className="absolute bottom-0 border-t-2 border-dark-grey text-center bg-dark-green w-full p-2 h4">{item.cta_label}</div></PrismicLink>
        }
      </div>
      <PrismicRichText field={item.title} />
    </div>
  </div>
}
const Pictures = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-${slice.primary.bg_color} overflow-x-hidden relative ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]"></div>

      <div className="md:px-7 lg:px-10 max-w-[1400px] m-auto text-dark-grey relative z-[10] py-30px md:py-20">
        {
          slice.primary.title[0] && slice.primary.title[0].text && <div className="px-4 md:text-left mb-30px md:mb-[50px]">
            <PrismicRichText field={slice.primary.title} />
          </div>
        }

        <Carousel items={slice.primary.pictures} Component={PictureItem} gap="gap-x-6 px-12" hidden="md:hidden" cpntProps={{ variation: slice.variation }}
          observersOption={{
            rootMargin: "0px",
            threshold: .9,
            delay: 100
          }}></Carousel>

        <div className={`hidden md:flex flex-row gap-x-5  ${slice.variation === "default" ? 'lg:gap-x-10' : 'lg:gap-x-20'}`}>
          {
            slice.primary.pictures.map((picture, i) => <PictureItem i={i} key={i} item={picture} variation={slice.variation} />)
          }
        </div>

      </div>


    </section >
  );
};

export default Pictures;
